import React, { useContext, useEffect, useState } from "react";

import supabase from "../supabase/supabaseClient";
import estilo from "./styles/Video.module.css";

import slider from "../img/slider.webm";

import { DataContext } from "../context/DataContext";

function Video({ usuario }) {
  const { urlVideos } = useContext(DataContext);

  const [videos, setVideos] = useState([]);

  useEffect(() => {
    const fetchVideos = async () => {
      const { data } = await supabase.storage
        .from("videos")
        .list(`${usuario}`, {
          limit: 1,
          offset: 0,
          sortBy: { column: "name", order: "asc" },
        });
      if (data) {
        // console.log("videos", data);
        setVideos(data);
      }
    };

    fetchVideos();
  }, [usuario]);

  const [activar, setActivar] = useState(false);

  //controlar la carga de iframe
  useEffect(() => {
    setActivar(false);
  }, [usuario]);

  function handleLoad() {
    setActivar(true);
  }

  return (
    <div className={estilo.video}>
      {videos.map((e, i) => (
        <div key={i} className={estilo.contenedor}>
          {activar ? null : (
            <video width="1280" height="720" loop autoPlay>
              <source src={slider} type="video/webm" />
              Tu navegador no soporta la etiqueta de video.
            </video>
          )}

          <iframe
            width="1280"
            height="720"
            src={urlVideos + usuario + "/" + e.name}
            title={e.name}
            frameBorder="0"
            allowFullScreen
            allow="autoplay; encrypted-media"
            style={{
              display: activar ? "" : "none",
              backgroundColor: "#111111",
            }}
            onLoad={handleLoad}
          ></iframe>
        </div>
      ))}
    </div>
  );
}

export default Video;
